export default __webpack_public_path__ + "static/media/baby-24.94617dfc.svg";